import { BaseRouteService } from "./BaseRouteService";

export interface HighscoreEntry {
    username: string;
    time: number;
}

export class HighscoreService extends BaseRouteService {
    public async getHighscores(): Promise<HighscoreEntry[]> {
        return this.getJsonApi<HighscoreEntry[]>("game/highscores");
    }

    public async submitHighscore(entry: HighscoreEntry): Promise<void> {
        await this.postJsonApi("game/highscores", entry);
    }
}
